import axiosOrders from '../../axios/quickOrders';
import axiosJupiter from '../../axios/jupiter';
import axiosAuth from '../../axios/auth';
var qs = require( 'qs' ); // necessary for stringifying json for http requests to API

import router from '../../router/router';

const state = {

    currentMerchant         : JSON.parse( localStorage.getItem( 'currentMerchant'   ) ) || {},
    currentMerchantLocation : JSON.parse( localStorage.getItem( 'currentLocation'   ) ) || null,
    merchantLocations       : JSON.parse( localStorage.getItem( 'merchantLocations' ) ) || [],
    PickupSpotByLocation    : JSON.parse( localStorage.getItem( 'PickupSpotByLocation' ) ) || [],
    DeliverySelected        : JSON.parse( localStorage.getItem( 'DeliverySelected' ) ) || [],
    locationError           : null,
    merchantsWithImages     : JSON.parse( localStorage.getItem( 'merchantsWithImages' ) ) || [],
    payOnPickup             : JSON.parse( localStorage.getItem( 'payOnPickup' ) ) || null,
    payWithCreditCard       : JSON.parse( localStorage.getItem( 'payWithCreditCard' ) ) || null,
    orderError              : null,
    isLoading               : false,
    currentTab              : JSON.parse( localStorage.getItem( 'cart' ) ) || null,
    deliveryFee             : JSON.parse( localStorage.getItem( 'activeOrder' ) ) || 0,
};

const mutations = {

    setLocationError( state, err ){

        state.locationError = err;
    },
    setLocations( state, locations ){

        state.merchantLocations = locations;
        localStorage.setItem( 'merchantLocations', JSON.stringify( locations ) );
    },
    setPickupSpot( state, PickupSpot ){

        state.PickupSpotByLocation = PickupSpot;
        localStorage.setItem( 'PickupSpotByLocation', JSON.stringify( PickupSpot ) );
    },
    setDeliverySelected( state, deliverySelected ){

        state.DeliverySelected = deliverySelected;
        localStorage.setItem( 'DeliverySelected', JSON.stringify( deliverySelected ) );
    },
    setCurrentLocation( state, location ){

        state.currentMerchantLocation = location;
        localStorage.setItem( 'currentLocation', JSON.stringify( location ) );
    },
    setPayOnPickup( state, valuePayOnPickup ){
        var payOnPickup = null;
        state.payOnPickup = valuePayOnPickup;
        payOnPickup = (valuePayOnPickup === "1") ? true : false;

        localStorage.setItem( 'payOnPickup', JSON.stringify( payOnPickup ) );
    },
    setPayWithCreditCard( state, payWithCreditCard ){
        state.payWithCreditCard = payWithCreditCard;
        localStorage.setItem( 'payWithCreditCard', JSON.stringify( payWithCreditCard ) );
    },
    updateCurrentMerchant( state, merchantInfo ){

        console.log( 'update current merchant mutation: ', merchantInfo );
        state.currentMerchant = merchantInfo;
        localStorage.setItem( 'currentMerchant', JSON.stringify( merchantInfo ) );
    },
    setMerchantsWithImages( state, merchantsWithImages ){

        state.merchantsWithImages = merchantsWithImages;
        localStorage.setItem( 'merchantsWithImages', JSON.stringify( merchantsWithImages ) );
    },
    clearData( state ){

        state.merchantLocations         = [];
        state.PickupSpotByLocation      = [];
        state.DeliverySelected          = [];
        state.currentMerchant           = null;
        state.currentMerchantLocation   = null;
        state.merchantsWithImages       = [];
        state.payOnPickup               = null;
        state.payWithCreditCard         = null;
        localStorage.removeItem( 'merchantLocations'    );
        localStorage.removeItem( 'currentMerchant'      );
        localStorage.removeItem( 'currentLocation'      );
        localStorage.removeItem( 'PickupSpotByLocation' );
        localStorage.removeItem( 'DeliverySelected'     );
        localStorage.removeItem( 'merchantsWithImages'  );
        localStorage.removeItem( 'payOnPickup'          );
        localStorage.removeItem( 'payWithCreditCard'    );
    },
    orderError              : ( state, value ) => state.orderError = value,
    setIsLoading            : ( state, value ) => state.isLoading = value,
};

const actions = {

    // thoughts: when switching merchants, reset locations to [] so 'needsLocations' goes to true
    getLocations( { commit, getters } ) {

        axiosOrders({

            method: 'post',
            url: '/getLocations',
            data: qs.stringify( {

                merchantId: getters.currentMerchant.merchantId,
            } ),
            headers: {

                'Content-Type' : 'application/x-www-form-urlencoded',
                'AuthType'     : 'JWT',
                'ApiKey'       : process.env.VUE_APP_API_KEY
                //'Token'        : localStorage.getItem( 'token' ) || 'null'
            }
        }).then( res => {

            console.log( 'response: ', res );
            if( res.data.responseCode == 100 ){

                const locations = res.data.data;

                let formattedLocations = [];

                let formattedPickupSpot = [];

                Object.values( locations ).forEach( location => {

                    formattedLocations.push( {

                        'name'                       : location.MerchantLocation.name,
                        'merchantId'                 : location.MerchantLocation.merchantId,
                        'locationId'                 : location.QuickMerchantLocation.merchantLocationId,
                        'menuLocationId'             : location.QuickMerchantLocation.quickMerchantLocationId,
                        'imagePath'                  : location.Image.path,
                        'imageName'                  : location.Image.name,
                        'menuVersion'                : location.QuickMerchantLocation.menuVersion,
                        'tipEnabled'                 : location.QuickMerchantLocation.tipEnabled,
                        'acceptingOrders'            : location.QuickMerchantLocation.acceptingOrders,
                        'phoneNumber'                : location.QuickMerchantLocation.phoneNumber,
                        'waitTime'                   : location.QuickMerchantLocation.waitTime,
                        'buildingDelivery'           : location.QuickMerchantLocation.buildingDelivery,
                        'buildingDescriptionLabel'   : location.QuickMerchantLocation.buildingDescriptionLabel,
                        'fullDelivery'               : location.QuickMerchantLocation.fullDelivery,
                        'pickupCounter'              : location.QuickMerchantLocation.pickupCounter,
                        'pickupSpot'                 : location.QuickMerchantLocation.pickupSpot,
                        'payOnPickupEnabled'         : location.QuickMerchantLocation.payOnPickupEnabled,
                        'payWithCreditCard'          : location.payWithCreditCard,
                        'deliveryFee'                : location.QuickMerchantLocation.deliveryFee ? location.QuickMerchantLocation.deliveryFee : 0.00,
                    });

                    if( location.QuickMerchantLocation.pickupSpot ){
                        Object.values( location.QuickPickupSpot ).forEach( spot => {
                            formattedPickupSpot.push({
                                'quickPickupSpotId'         : spot.quickPickupSpotId,
                                'quickMerchantLocationId'   : spot.quickMerchantLocationId,
                                'name'                      : spot.name,
                                'displayName'               : spot.displayName,
                                'description'               : spot.description
                            });
                        });
                    }
                });

                console.log('formattedLocations', formattedLocations);
                console.log('formattedPickupSpot', formattedPickupSpot);

                commit( 'setLocationError', null );
                commit( 'setLocations', formattedLocations );
                commit( 'setPickupSpot', formattedPickupSpot );
                //localStorage.removeItem( 'DeliverySelected'   );
            }
        }).catch( err => {

            console.log( 'the error: ', err );
            commit( 'setLocationError', err );
        });
    },
    selectedDelivery( { commit, getters, dispatch, rootGetters }, input ){
        commit( 'setDeliverySelected', input );
    },
    resetError( {commit} ){
        commit( 'orderError', null );
    },
    getDeliveryFee( { commit, getters, dispatch }, input ){
        console.log(input);
        let uuid = JSON.parse( localStorage.getItem( 'activeOrder' ) ).uuid;
        console.log( 'uuid: ' + uuid );

        const deliveryData = {
            uuid: uuid,
            address: input.addressOne,
            address2: input.addressTwo,
            city: input.addressCity,
            state: input.addressState,
            zipCode: input.addressZip,
            country: input.addressCountry,
        }

        console.log('Delivery Data to Send to Jupiter Backend')
        console.log(deliveryData)

        let merchantId = getters.currentMerchant.merchantId
        let locationId = getters.currentLocation.locationId

        commit( 'setIsLoading', true );

        axiosOrders({

            method: 'post',
            url: '/deliveryQuote/' + merchantId + '/' + locationId,
            data: qs.stringify( deliveryData )
        }).then( res => {

            console.log( 'Response jupiter with delivery fee: ', res.data );
            //possible error code 400 missing data | 404 not found | 100 ok
            if( res.data.responseCode == 100 ){
                commit( 'setIsLoading', false );
                console.log('getting a DeliveryFee...');
                console.log(res.data.deliveryFee);
    
                const order = {
                    uuid: uuid,
                    deliveryFee: res.data.deliveryFee
                };
    
                dispatch( 'orders/setActiveOrder', order, { root: true } );
    
                commit( 'orderError', null );
                console.log('getters.deliverySelected')
                console.log(getters.deliverySelected != '')
                let currentTab = JSON.parse( localStorage.getItem( 'cart' ) ) || [];
                console.log(currentTab != '')
                console.log(getters.deliverySelected != '' && currentTab != null && currentTab.length > 0)
                if ( getters.deliverySelected != '' && currentTab != null  && currentTab.length > 0) {
                    console.log(input.goToOrderTab)
                    router.replace({
                        name: 'order-tab'
                    });
                } else {
                    console.log(input.goToOrderTab)
                    if (input.goToOrderTab) {
                        router.replace({
                            name: 'order-tab'
                        });
                    } else {
                        router.push({

                            name: 'order-menu',
                            params: { slug : getters.merchantSlug }
                        });
                    }                  
                }

            } else {
                commit( 'setIsLoading', false );

                const order = {
                    uuid: uuid,
                    deliveryFee: 0
                };

                dispatch( 'orders/setActiveOrder', order, { root: true } );

                router.push({

                    name : 'full-delivery'
                });

                commit( 'orderError', "Sorry! We are currently unable to process this information. Please try again later." );

                return false
            }
            
        }).catch( err => {
            commit( 'setIsLoading', false );
            commit( 'orderError', "Sorry! We are currently unable to process this information. Please try again later." );
            console.log( 'No response jupiter with delivery fee: ', err );
            const order = {
                uuid: uuid,
                deliveryFee: 0
            };

            dispatch( 'orders/setActiveOrder', order, { root: true } );

            router.push({

                name : 'full-delivery'
            });

            return false

        });
    },
    selectLocation( { commit, getters, dispatch, rootGetters }, input ){

        if (input.deleteDeliverySelected) {
            localStorage.removeItem('DeliverySelected');
        }

        // console.log( 'intended route BEFORE CLEAR: ', rootGetters[ 'nav/intendedRoute' ] );
        // console.log( 'merchantslug BEFORE CLEAR: ', rootGetters[ 'merchant/merchantSlug' ] );
        if( input.refreshMenu ) dispatch( 'orderMenu/changeLocation', null, { root: true } ); // clears menu data in browser, but not indexedDB. This is re-set during the menu function call
        commit( 'setCurrentLocation', input.location );
        //console.log('NEW input.location ==> ');
        //console.log(input.location);
        commit( 'setPayOnPickup', input.location.payOnPickupEnabled );
        commit( 'setPayWithCreditCard', input.location.payWithCreditCard );
        // console.log( 'intended route AFTER CLEAR: ', rootGetters[ 'nav/intendedRoute' ] );
        // console.log( 'merchantslug AFTER CLEAR: ', rootGetters[ 'merchant/merchantSlug' ] );
        router.push({

            name : [ "", null ].includes( rootGetters.previousRoute.name ) ? 'home' : rootGetters[ 'nav/intendedRoute' ] != null ? rootGetters[ 'nav/intendedRoute' ] : rootGetters.previousRoute.name,
            params : { slug : rootGetters[ 'merchant/merchantSlug' ] }
        });
        dispatch( 'nav/saveIntendedRoute', null, { root: true } );
    },
    updateCurrentLocationAfterOrder( { commit, getters }, data ){

        let currentLocation = getters.currentLocation;
        currentLocation.waitTime = data.waitTime;
        currentLocation.phoneNumber = data.phoneNumber;
        commit( 'setCurrentLocation', currentLocation );
    },
    updateCurrentMerchant( { commit }, merchantData ){

        commit( 'updateCurrentMerchant', merchantData );
    },
    identifyBySlug( { commit, dispatch }, slug ){

        axiosOrders({

            method: 'post',
            url: '/identifyBySlug',
            data: qs.stringify( { slug : slug } )
        }).then( res => {

            console.log( 'response lol: ', res );
            if( res.data.responseCode == 100 ){

                commit( 'updateCurrentMerchant', res.data.merchant );
            } else throw res.data.message;
        }).catch( err => {
            // no merchant found, clear application state

            console.log( 'the error: ', err );
            dispatch( 'clearIndexDb', null, { root : true } );
            dispatch( 'updateLoadingStatus', 'Invalid Parameters!', { root : true } );
            router.push({

                name : 'not-found'
            });
        });
    },
    getQuickOrderMerchants( { commit, dispatch } ){
        console.log( 'grabbing all merchants images..' );
        axiosJupiter({

            method: 'post',
            url: '/getQuickOrderMerchants'
        }).then( res => {

            console.log( 'response getQuickOrderMerchants: ', res );
            if( res.data.responseCode == 100 ){

                const objWithImages = res.data.body;
                let formattedMerchantsWithImages = [];

                for (var i=0;i<objWithImages.length;i++){
                    formattedMerchantsWithImages.push( {

                        'merchantId'        : objWithImages[i].Merchant.merchantId,
                        'slug'              : objWithImages[i].Merchant.slug,
                        'imageName'         : objWithImages[i].Image.name,
                        'imagePath'         : objWithImages[i].Image.path,
                    });
                }
                //console.log('formattedMerchantsWithImages ', formattedMerchantsWithImages);

                commit( 'setMerchantsWithImages', formattedMerchantsWithImages );

                console.log('getQuickOrderMerchants data => ', res.data);
            } else throw res.data.message;
        }).catch( err => {

            //console.log( 'the error: ', err );
            dispatch( 'clearIndexDb', null, { root : true } );
            dispatch( 'updateLoadingStatus', 'Error in the server!', { root : true } );
            router.push({

                name : 'not-found'
            });

        });
    },
    clearData( { commit } ){

        commit( 'clearData' );
    }
};

const getters = {

    allLocations              : state => state.merchantLocations,
    currentPickupSpot         : state => state.PickupSpotByLocation,
    deliverySelected          : state => state.DeliverySelected,
    allMerchants              : state => state.merchants,
    currentMerchant           : state => state.currentMerchant,
    currentLocation           : state => state.currentMerchantLocation,
    needsLocations            : state => state.merchantLocations.length == 0, // if there are no locations, we need to get some. UNDER ASSUMPTION EVERY MERCHANT HAS AT LEAST 1 LOCATION
    locationError             : state => state.locationError,
    merchantSlug              : state => state.currentMerchant == null ? null : state.currentMerchant.slug,
    allMerchantsWithImages    : state => state.merchantsWithImages,
    getPayOnPickupValue       : state => state.payOnPickup,
    getPayWithCreditCardValue : state => state.payWithCreditCard,
    orderError                : state => state.orderError,
    isLoadingOrder            : state => state.isLoading,
    currentTab                : state => state.currentTab,
    getValueDeliveryFee       : state => state.deliveryFee == 0 ? 0 : JSON.parse( localStorage.getItem( 'activeOrder' ) ).deliveryFee,
};

export default {

    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
